import { UtilService } from '../services/util.service';
import React, { useEffect, useState } from 'react';
import { IButton } from '../interfaces';
import { Tooltip } from 'antd';
import type { Colors } from '../constants/colors';

const COLOR_CLASS: Record<Colors, string> = {
  blue: 'ac-btn-primary',
  gray: 'ac-btn-secondary',
  red: 'ac-btn-danger',
  green: 'ac-btn-success',
  orange: 'ac-btn-warning',
  indigo: 'ac-btn-indigo',
  yellow: 'ac-btn-yellow',
};

const Button: React.FC<IButton> = ({
  icon,
  title,
  text,
  color,
  tone: _tone,
  disabled = false,
  btnClass,
  onClick,
}) => {
  const utils = UtilService.GetInstance();
  const [transition, setTransition] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const subscription = utils.OnTransition().subscribe((transitionState) => {
      setTransition(transitionState);
    });

    return () => subscription.unsubscribe();
  }, [utils]);

  const variantClass = COLOR_CLASS[color] ?? 'ac-btn-secondary';

  return (
    <Tooltip title={title} placement="bottom">
      <div className="flex items-center justify-center">
        <button
          type="button"
          className={`ac-btn ${variantClass} ${btnClass ?? ''} ${
            disabled || transition ? 'cursor-not-allowed opacity-60' : ''
          }`.trim()}
          disabled={transition || disabled}
          onClick={onClick}
        >
          {icon ? (
            <span className={`${text && !isMobile ? 'mr-1' : ''} ${icon.size}`}>
              {icon.value}
            </span>
          ) : null}
          {text ? (
            <span className={`${text.size} ${isMobile ? 'sr-only' : ''}`}>{text.value}</span>
          ) : null}
        </button>
      </div>
    </Tooltip>
  );
};

export default Button;
